import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import AuthContext from '@/product/context/auth/authContext'
import LoginComponent from './loginComponent'
import { loginSchema } from './loginSchema'
import { handleRedirectInternal } from '@/product/common/components'
import SEO from '@/utils/SEO'
import './Login.css'
import AuthLayout from '@/custom/components/molecules/AuthLayout'

const Login = () => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const vData = loginSchema()

    const { isAuthenticated, login } = authContext

    const handleredirection = () => {
        handleRedirectInternal(history, '')
    }

    useEffect(() => {
        if (isAuthenticated) {
            handleredirection()
        }
    }, [isAuthenticated])

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required'),
        password: Yup.string().required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            email: localStorage.email ? localStorage.email : '',
            password: localStorage.password ? localStorage.password : '',
            mail_verified: 1,
            remember_me: localStorage.remember_me ? localStorage.remember_me : false,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.remember_me) {
                localStorage.email = values.email
                localStorage.password = values.password
                localStorage.remember_me = values.remember_me
            } else {
                delete localStorage.email
                delete localStorage.password
                delete localStorage.remember_me
            }

            login(values)
        },
    })

    return (
        <>
            <SEO title="Login" url={window.location.href} />
            <AuthLayout
                title="Sign In"
                subtitle="India’s leading marketplace for end-to-end asset lifecycle management"
                bannerTitle="Welcome to iQuippo"
                bannerPoints={[
                    '95,000+ Registered Customers',
                    'Track Ongoing & Upcoming Auctions',
                    'Get Updated on Financing Offers',
                ]}
                bannerTags={['BUY', 'SELL', 'RENT', 'FINANCE', 'VALUATION']}
            >
                {' '}
                {/* <Link to="/">
                    <img className="brandLogo" src={LOGO} alt={SITE_NAME} width="200" height="40" />
                    </Link> */}
                <h1>{'Sign in'}</h1>
                <h2>{'Sign In to Get Started'}</h2>
                <LoginComponent
                    initialValues={vData.initialValues}
                    validationArray={vData.validationArray}
                    googleSignIn={true}
                    login={login}
                    formik={formik}
                    // rememberMe={vData.rememberMe}
                    forgotPassword={true}
                    facebookLogin={true}
                    loginInfo={vData.login.formData}
                    onSuccess={handleredirection}
                />
                {/* <Divider /> */}
                {/* <div className="loginMiscAction d-flex justify-content-between align-items-center">
                        <Link to="/forgot_password">{'Forgot password'}</Link>
                        <Link to="/registration">{'Register'}</Link>
                    </div> */}
            </AuthLayout>
        </>
    )
}

export default Login
